import React from 'react';
import { MuiHidden, MuiGrid, muiWithStyles } from '../../ui';
import SideNav from '../../ui/sideNav/SideNav';
import AppBar from '../../ui/appbar/Appbar'
import asProtectedPage from '../asProtectedPage/asProtectedPage';
import StateFulAppBar from '../../ui/appbar/StateFulAppBar';
import AppTabBar from '../../ui/appbar/AppTabBar';
import AppbarContainer from '../../ui/appbar/AppbarContainer'
import Drawer from '@material-ui/core/Drawer';
/**
 *
 * @param {*} WrappedComponent
 * @param {*} data is an object of all related props
 */

function withAppShell(WrappedComponent, props) {
    class AppShell extends React.Component {
        
        componentWillMount(){
            
        }
         toggleDrawer = (side, open, content) =>event => {
            if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
              return;
            }
            this.setState({ ...this.state, [side]: open,ContextualHelp:content });
          }
        render() {
            const { classes } = this.props;
            return (
                <MuiGrid xs={12} tyle={{ overflowX: 'hidden', height: '100%' }}>
                    
                    <AppbarContainer {...this.props} />
                    <SideNav {...this.props} {...this.state} direction='right' className={classes.drawer} toggleDrawer={this.toggleDrawer}/>
                    <MuiGrid id="componentGrid" container xs={12} sm={12} className={classes.componentContainer}>
                        {React.createElement(WrappedComponent, { ...this.props,toggleDrawer:this.toggleDrawer,tempToggleDrawer:this.tempToggleDrawer})}
                    </MuiGrid>
                </MuiGrid>
            )
        }
    }


    if (props != null && props.properties.isProtected == false) {
        return muiWithStyles(elementStyles)(AppShell)
    }
    return asProtectedPage(muiWithStyles(elementStyles)(AppShell))
}
   
const drawerWidth = 64;

const elementStyles = (theme) => ({
    container: {
        flex: 1,
        width: '80%',



    },
    drawer: {
        width: drawerWidth,
    },
    componentContainer: {
    // marginTop: drawerWidth,
        alignItems: 'center',
        width: '100%',
      //  padding: 8,
     
    }

});
export default withAppShell;
